import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import MaintenanceDashboard from "./MaintenanceDashboard";

const MaintenanceDashboardPage = () => {
  return (
    <NavHeightAdjust>
      <MaintenanceDashboard />
    </NavHeightAdjust>
  );
};

export default MaintenanceDashboardPage;
